import type { RouteObject } from 'react-router';
import { roleRoutes, rolePublicPaths } from '../sites/role/routes';
import { NotFound } from './NotFound';

/** Todas las rutas del sitio: este repo ya solo sirve `rolsensorial.com`. */
export function routes(): RouteObject[] {
  return [...roleRoutes, { path: '*', element: <NotFound /> }];
}

/** Si la ruta actual es alcanzable sin sesión iniciada. */
export function isPublicPath(pathname: string): boolean {
  return rolePublicPaths.exact.has(pathname) || rolePublicPaths.prefixes.some((prefix) => pathname.startsWith(prefix));
}
